import { gql, useMutation } from '@apollo/client';

import { OdProtosListingsData_PARNDidNotConvertReason as DECLINE_REASON } from '../../../__generated__/athenaGlobalTypes';
import { PARN_DETAILS_QUERY } from '../queries/ParnDetails';
import { ParnDidNotConvert, ParnDidNotConvertVariables } from './__generated__/ParnDidNotConvert';

export const PARN_DID_NOT_CONVERT = gql`
  mutation ParnDidNotConvert(
    $parnId: String!
    $reason: OdProtosListingsData_PARNDidNotConvertReason!
  ) {
    odProtosListingsServicesPartneragentreferralnetwork {
      pARNDidNotConvert(input: { parnId: $parnId, reason: $reason }) {
        _empty
      }
    }
  }
`;

/**
 * If the lead did not convert prior to signing a listing agreement, this mutation should be called
 * to set the reason why.
 */
export const useParnDidNotConvert = () => {
  const [parnDidNotConvertMutation, { data, error, loading }] = useMutation<
    ParnDidNotConvert,
    ParnDidNotConvertVariables
  >(PARN_DID_NOT_CONVERT, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [PARN_DETAILS_QUERY],
  });

  const setParnDidNotConvert = (parnId: string, reason: DECLINE_REASON) =>
    parnDidNotConvertMutation({
      variables: { parnId, reason },
    });
  return { setParnDidNotConvert, data, loading, error };
};
